import { defineStore } from 'pinia';
export const useMonitoringStore = defineStore('monitoringCenter', {
    state: () => {
        return {
            videoDetailArr: new Array(4).fill({}),
            videoSettingArr: [],
            currDeviceId: '',
            currDeviceNode: null,
            treeData: [],
            singleScreen: true,
            fullScreen: false,
            escfullScreenStatus: true,
            dragDevice: null,
            alarmDeviceId: '',
            alarmTaskId: '',
            taskList: [],
            selectMap: new Map(),
            deviceIdMap: new Map(),
            selectTrackIds: []
        };
    },
    getters: {
        selectedDevices() {
            return this.videoDetailArr.filter((item) => item?.deviceId).map((item) => item.deviceId);
        },
        isDeviceDragging() {
            return !!this.dragDevice;
        },
        checkedTasks() {
            // 任务告警展示List
            return this.taskList.filter((item) => item.checked).map((item) => item.id);
        },
        recieveAlerts() {
            // 接收任务告警弹框List
            return this.taskList.filter((item) => item.recieveAlert).map((item) => item.id);
        },
    },
    actions: {
        updateVideoDatailData(data) {
            this.videoDetailArr = data;
        },
        updateVideoSettingData(data) {
            const position = this.videoSettingArr.findIndex((item) => item.deviceId === data.deviceId);
            if (position > -1) {
                this.videoSettingArr.splice(position, 1, data);
            }
            else {
                this.videoSettingArr.push(data);
            }
        },
        updateVideoSettingArrData(data) {
            this.videoSettingArr = data;
        },
        handleCurrDevice(id) {
            this.currDeviceId = id;
        },
        updateCurrDeviceNode(data) {
            this.currDeviceNode = data;
        },
        updateTreeData(data) {
            this.treeData = data;
        },
        toggleSingleScreen(status) {
            this.singleScreen = status;
        },
        toggleFullScreen(status) {
            this.fullScreen = status;
        },
        toggleEscfullScreenStatus(status) {
            this.escfullScreenStatus = status;
        },
        updateDragDevice(data) {
            this.dragDevice = data;
        },
        updateAlarmDeviceId(deviceId) {
            this.alarmDeviceId = deviceId;
        },
        updateAlarmTaskId(taskId) {
            this.alarmTaskId = taskId;
        },
        updateTaskList(list) {
            this.taskList = list;
        },
        updateSelectMap(data) {
            const { trackId, taskId, taskName, deviceId, level } = data;
            const updateTime = new Date().getTime();
            const taskIdArr = [taskId];
            const taskMsg = {
                taskName,
                level,
                taskId
            };
            const taskNameArr = [taskMsg];
            const selectMapObj = {
                trackId,
                taskIdArr,
                taskNameArr,
                deviceId,
                level
            };
            const key = `${trackId}-${taskId}-${deviceId}`;
            if (this.selectMap.has(key)) {
                const taskIdArr = this.selectMap.get(key).taskIdArr;
                const taskNameArr = this.selectMap.get(key).taskNameArr;
                taskIdArr.push(taskId);
                const taskMsg = {
                    taskName,
                    level,
                    taskId
                };
                taskNameArr.push(taskMsg);
                const set = new Set(taskIdArr);
                const duplicationTaskIdArr = Array.from(set);
                const duplicationTaskNameArr = [...new Set(taskNameArr.map((t) => JSON.stringify(t)))].map((s) => JSON.parse(s));
                selectMapObj.taskIdArr = duplicationTaskIdArr;
                selectMapObj.taskNameArr = duplicationTaskNameArr;
            }
            this.selectMap.set(key, { ...selectMapObj, updateTime });
            this.deviceIdMap.set(deviceId, { ...selectMapObj, updateTime });
            if (!this.selectMap.has(key)) {
                this.selectTrackIds.push(String(trackId));
            }
        }
    },
});
